import {
    GETENTITYTYPELISTABLE_SUCCESS,
    GETENTITYTYPELISTABLE_FAILED,
    RESET_GETENTITYTYPELISTABLE,
    LOADING_GETENTITYTYPELISTABLE,
    NETWORK_ERROR_GETENTITYTYPELISTABLE,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETENTITYTYPELISTABLE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETENTITYTYPELISTABLE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETENTITYTYPELISTABLE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETENTITYTYPELISTABLE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETENTITYTYPELISTABLE:
            return (state = initialState);
        default:
            return state;
    }
};
